import React from 'react';
import { Box, Tabs } from '@material-ui/core';
import { TableAction } from '../../../../../services/Main/types.Component';
import TableActionComponent from '../../../../lowLevel/TableAction/TableAction';
import TableActionButton from '../../../../lowLevel/TableAction/TableAction.Button';
import ExtraActions from '../../../../lowLevel/ExtraActions';
import ExtraActionsMenuItem from '../../../../lowLevel/ExtraActions/ExtraActions.MenuItem';
import { useClassifyActions } from '../../../../lowLevel/ExtraActions/useClassifyActions';
import useStyles from './TableSelectionPanel.styles';

interface TableSelectionPanelDesktopProps {
  actions?: TableAction[];
  disabled?: boolean;
}

const TableSelectionPanelDesktop = ({
  actions,
  disabled = false,
}: TableSelectionPanelDesktopProps) => {
  const classes = useStyles();

  const { mainActions, extraActions } = useClassifyActions<TableAction>(
    actions || []
  );

  return (
    <Box className={classes.actionsWrapper}>
      <Tabs
        variant="scrollable"
        textColor="primary"
        value={false} // см. аннотацию свойства
      >
        {mainActions.map((actionProps) => (
          <TableActionComponent
            key={`desktop_main_${Object.values(actionProps).join('')}`}
            action={actionProps}
            renderAction={TableActionButton}
            disabled={disabled}
          />
        ))}
        {extraActions.length > 0 && (
          <ExtraActions<TableAction>
            actions={extraActions}
            renderMenuItem={(actionProps, onClickMenuItem) => (
              <TableActionComponent
                key={`desktop_extra_${Object.values(actionProps).join('')}`}
                action={actionProps}
                onClick={onClickMenuItem}
                renderAction={ExtraActionsMenuItem}
                disabled={disabled}
              />
            )}
          />
        )}
      </Tabs>
    </Box>
  );
};

export default TableSelectionPanelDesktop;
